export default "__VITE_ASSET__69Rcy1vl__"